/**
 * @description 支付
 */
export default [
    {
        path: "/pay/online", //线上支付
        name: "pay_online",
        component: () => import("@/views/pay/PayOnline.vue"),
        meta: {
            title: "线上支付-油柑网",
            requiresAuth: true,
        },
    },
    {
        path: "/pay/offline", //线下支付
        name: "pay_offline",
        component: () => import("@/views/pay/PayOffline.vue"),
        meta: {
            title: "线下支付-油柑网",
            requiresAuth: true,
        },
    },
    {
        path: "/pay/remittance", //汇款
        name: "pay_remittance",
        component: () => import("@/views/pay/Remittance.vue"),
        meta: {
            title: "公对公支付-油柑网",
            requiresAuth: true,
        },
    },
    {
        path: "/pay/success", //支付成功
        name: "pay_success",
        component: () => import("@/views/pay/Success.vue"),
        meta: {
            title: "支付结果-油柑网",
            requiresAuth: true,
            bodyColor: true,
        },
    },
    {
        path: "/pay/select", //选择支付
        name: "pay_select",
        component: () => import("@/views/pay/Select.vue"),
        meta: {
            title: "支付选择-油柑网",
            requiresAuth: true,
        },
    },
    {
        path: "/pay/wallet", //选择支付
        name: "pay_wallet",
        component: () => import("@/views/pay/Wallet.vue"),
        meta: {
            title: "钱包支付-油柑网",
            requiresAuth: true,
        },
    },
];
